<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";
	import {
		convertDateOnly,
		convertTimeOnly,
	} from "../../../services/helpers";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let handleInactive;
	export let handleResetPin;
	export let data;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Card Number</th>
				<th>Fuel Company</th>
				<th>Car Plate Number</th>
				<th>Pin</th>
				<th>Last Updated</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, cardNumber, fuelCompany, carPlateNumber, pin, status, createdAt, updatedAt }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() => {
								navigate(`/fuel-card-management/edit?id=${id}`);
							}}
						>
							<span class="link link-text"> {cardNumber} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {fuelCompany} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {carPlateNumber} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {pin} </span>
						</p>
					</td>
					<td>
						<p>
							{#if convertDateOnly(updatedAt) === "Invalid date"}
								<span>Never</span>
							{:else}
								<span> {convertDateOnly(updatedAt)} </span>
								<br />
								<span> {convertTimeOnly(updatedAt)} </span>
							{/if}
						</p>
					</td>
					<td>
						{#if status === true}
							<p class="status-bar status-bar-1">Active</p>
						{:else if status === false}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() => {
									navigate(
										`/fuel-card-management/edit?id=${id}`
									);
								}}>Edit Details</DropdownItem
							>
							{#if status === true}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Inactive</DropdownItem
								>
							{:else if status === false}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Active</DropdownItem
								>
							{/if}
							<DropdownItem on:click={() => handleResetPin(id)}
								>Reset Pin</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0 || !data.totalCount}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.totalCount || 0} />
	<CustomModal />
</LoaderContainer>
